import { CUSTOM_MAP_LAYER_STYLE } from './style_defaults'

/**
 * Resolve per-feature style from layer data and GeoJSON properties.
 * Fallback chain: layer-level -> feature properties -> defaults.
 *
 * @param {Object} layerData - Layer-level settings (stroke_color, feature_name, description)
 * @param {Object} properties - GeoJSON feature properties
 * @returns {{ shapeStyle: Object, metadata: Object }}
 */
export function resolveFeatureStyle(layerData, properties) {
  const strokeColor = layerData.stroke_color ||
                     properties.stroke ||
                     properties['stroke-color'] ||
                     CUSTOM_MAP_LAYER_STYLE.strokeColor
  const fillColor = layerData.stroke_color ||
                   properties.fill ||
                   strokeColor
  const fillOpacity = properties['fill-opacity'] ?? CUSTOM_MAP_LAYER_STYLE.fillOpacity
  const strokeWeight = properties['stroke-width'] ?? CUSTOM_MAP_LAYER_STYLE.strokeWeight
  const strokeOpacity = properties['stroke-opacity'] ?? CUSTOM_MAP_LAYER_STYLE.strokeOpacity
  const featureName = layerData.feature_name || properties.name || null
  const description = layerData.description || properties.description || null

  const shapeStyle = { strokeColor, fillColor, fillOpacity, strokeWeight, strokeOpacity }
  const metadata = { featureName, description, strokeColor, fillColor, fillOpacity, strokeWeight, sourceType: layerData.source_type || 'custom' }

  return { shapeStyle, metadata }
}
